module.exports = __webpack_public_path__ + "img/326.661b032d.svg";